module.exports = __webpack_public_path__ + "img/120.378f875d.jpg";